import React from 'react';
import styled from 'styled-components';

const IconH = styled.div`
  width: 18px;
  height: 18px;
  > svg {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  > svg:hover circle {
    fill: #caced8;
  }
`;
export default function IconHover() {
  return (
    <IconH>
      <svg
        id="Componente_26_2"
        data-name="Componente 26 – 2"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <circle id="Elipse_378" data-name="Elipse 378" cx="8" cy="8" r="8" fill="#838aa2" />
        <text
          id="_"
          data-name="?"
          transform="translate(5 12)"
          fill="#fff"
          stroke="rgba(0,0,0,0)"
          strokeWidth="1"
          fontSize="12"
          fontFamily="Roboto-Medium, Roboto"
          fontWeight="500"
        >
          <tspan x="0" y="0">
            ?
          </tspan>
        </text>
      </svg>
    </IconH>
  );
}
